<header class="qc-header">

	<img
		*ngIf="!appSwitch"
		[src]="uiConfigBrandLogo || headerLogo" class="qc-header__logo"
		[ngClass]="{'qc-header__ui-config-brand-logo': uiConfigBrandLogo}"
	/>

    <cv-dropdown-button
      *ngIf="appSwitch"
      class="app-switch-dropdown"
      [label]="appDropdown.image"
      [isImg]="true"
      [icon]="'fa-store-alt'"
      [position]="'down'"
      [buttonClass]="'btn-sm cv-btn-light'"
      [items]="appOptions"
      (subOptionClick)="goToApp($event)"
    >
    </cv-dropdown-button>

    <div class="qc-header__right-content cv-tab-label">
      <i
        *ngIf="showInboxButton()"
        #inboxBadge
        class="fas fa-inbox qc-header__right-content__item"
        (click)="toggleInbox()"
        cvTooltip
        [tooltipText]="'Inbox'"
        [tooltipPlacement]="'bottom'"
      >
        <span
          *ngIf="getNewEventsCount() > 0"
          class="badge rounded-pill badge-warning bg-warning"
          >+{{ getNewEventsCount() }}</span
        >
      </i>
      <i
        cvTooltip
        [tooltipText]="'Sign-out'"
        [tooltipPlacement]="'bottom'"
        class="fas fa-sign-out-alt qc-header__right-content__item"
        (click)="logout()"
      ></i>
      <div class="profile-user__container">
        <span #initials class="initials" (click)="toggleUserProfile()">{{
          user.initials
        }}</span>
        <span class="full-name">{{ user.fullName }}</span>
      </div>
    </div>

    <!-- Order Event Inbox -->
    <div #inbox class="menu-context-box cv-event-inbox">
      <div class="new_messages_available">
        You have {{ getNewEventsCount() }} new message(s)
        <button
          [disabled]="!getNewEventsCount()"
          (click)="markAllAsRead()"
          type="button"
          class="btn btn-link mark-all-as-read"
        >
          Mark All as Read
        </button>
      </div>
      <hr />
      <div class="event-wrapper">
        <div *ngFor="let order of filteredOrderList">
          <cv-order-event-notification
            [orderEvent]="order"
            [module]="module"
            (toggleInbox)="toggleInbox()"
          >
          </cv-order-event-notification>
        </div>
      </div>
    </div>
    <div #userProfile class="menu-context-box cv-user-profile">
      <div class="title">USER INFO</div>
      <div class="full-name-field">
        Name: {{ user.fullName }}
        <span class="username">Username: {{ user.userName }} </span>
      </div>
      <hr />
      <div class="field">
        Organization:
        {{ user.organizationName ? user.organizationName : 'N/A' }}
      </div>
      <!-- div class="field">
				Roles: {{user.roles}}
			</div -->
      <div class="field">Email: {{ user.email }}</div>
    </div>
</header>

<cv-download-link *ngFor="let link of downloadableLinks"
	[downloadableLink]="link">
</cv-download-link>
